import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ArrowLeft, Mail, CheckCircle } from "lucide-react";
import TopBar from "@/components/TopBar";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useI18n } from "@/contexts/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("forgot_send"));
    } catch (er) {
      toast.error(formatApiError(er.response?.data?.detail) || er.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-app">
      <TopBar />
      <div className="flex items-center justify-center min-h-[calc(100vh-56px)] px-4 py-8 radial-glow">
        <div className="w-full max-w-md bg-panel border border-line rounded-sm p-6 sm:p-8">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-8 h-8 bg-buy flex items-center justify-center rounded-sm">
              <TrendingUp className="w-5 h-5 text-black" />
            </div>
            <span className="text-xl font-bold">IQ<span className="text-buy">Trade</span></span>
          </div>

          {!sent ? (
            <>
              <h1 className="text-2xl font-bold mb-2 tracking-tight">{t("forgot_title")}</h1>
              <p className="text-sm text-muted mb-6">
                {t("forgot_desc")}
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-[10px] uppercase tracking-widest text-dim">{t("email")}</label>
                  <input
                    type="email" required value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mt-1.5 bg-app border border-line px-3 py-2.5 rounded-sm outline-none focus:border-buy"
                    placeholder={t("forgot_email_placeholder")}
                  />
                </div>
                <button disabled={busy} type="submit"
                  className="w-full bg-buy text-black font-bold py-3 rounded-sm hover:bg-emerald-400 disabled:opacity-50 uppercase tracking-widest text-sm">
                  {busy ? t("forgot_sending") : t("forgot_send")}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center py-4">
              <div className="w-16 h-16 bg-buy/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-8 h-8 text-buy" />
              </div>
              <h1 className="text-2xl font-bold mb-2">{t("forgot_sent_title")}</h1>
              <p className="text-sm text-muted mb-6">
                <strong>{email}</strong> {t("forgot_sent_desc")}
              </p>
              <p className="text-xs text-dim mb-4">
                {t("forgot_sent_note")}
              </p>
            </div>
          )}

          <div className="mt-6 text-sm text-muted text-center">
            <Link to="/login" className="inline-flex items-center gap-1 text-buy hover:underline">
              <ArrowLeft className="w-4 h-4" /> {t("back_to_login")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
